module.exports = __webpack_public_path__ + "img/pausebtn.768b8ee9.png";